export default __webpack_public_path__ + "static/media/Calibri.29c57b05.ttf";